import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ClipboardPaste, Plus } from "lucide-react";

/**
 * "Importer fra notater" dialog — paste a plain-text shopping list (one item
 * per line). Presentation-only: parent owns `notesText`/setter and the actual
 * `onImport` parser+API-call handler.
 */
export default function ImportNotesDialog({
  open,
  onOpenChange,
  notesText,
  setNotesText,
  onImport,
}) {
  const lineCount = notesText.split("\n").filter((l) => l.trim()).length;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="import-notes-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            <ClipboardPaste className="h-5 w-5 text-navy-800" /> Importer fra notater
          </DialogTitle>
          <DialogDescription>Lim inn handlelisten din fra notater. En vare per linje.</DialogDescription>
        </DialogHeader>
        <textarea
          value={notesText}
          onChange={(e) => setNotesText(e.target.value)}
          placeholder={"2 dl melk\n500g kjøttdeig\nBrød\n3 stk paprika\nOst\nSmør\nToalettpapir"}
          className="w-full rounded-md border border-stone-200 bg-white px-3 py-2 text-sm focus:border-navy-800 focus:ring-1 focus:ring-navy-800 outline-none resize-none min-h-[200px] font-mono"
          data-testid="notes-textarea"
        />
        <div className="flex items-center justify-between">
          <span className="text-xs text-stone-400">{lineCount} varer</span>
          <button
            onClick={onImport}
            disabled={!notesText.trim()}
            className="inline-flex items-center gap-2 rounded-md bg-navy-800 px-4 py-2 text-sm font-medium text-white hover:bg-navy-900 transition-colors disabled:opacity-50"
            data-testid="import-notes-submit"
          >
            <Plus className="h-4 w-4" /> Importer varer
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
